import React, { useEffect, useState } from 'react'
import { Form, Input, Button, Col, Row, Select } from 'antd'
import apiRequest from '../../hooks/ApiRequest'
import { toast } from 'react-toastify'

const { Option } = Select

const InsurerForm = props => {
  const { form, insurerID, onSuccess } = props
  const { getFieldDecorator } = form
  const [loading, setLoading] = useState(false)
  const [productList, setProductList] = useState([])
  const [borkerList, setBrokerList] = useState([])

  useEffect(() => {
    fetchProducts()

    if (insurerID) {
      fetchUserDetails(insurerID)
    } else {
      form.resetFields()
    }
  }, [insurerID])

  // Fetch available products
  const fetchProducts = async () => {
    try {
      const response = await apiRequest(
        process.env.REACT_APP_BASE_URL_ADMIN + '/Product/GetAllProducts',
        'GET',
      )
      // const borokerList = await apiRequest(
      //   process.env.REACT_APP_BASE_URL_AUTH + '/api/Auth/brokerList',
      //   'GET',
      // )
      setProductList(response?.data?.data)
      //setBrokerList(borokerList?.data)
    } catch (error) {
      console.error('Error fetching products:', error)
    }
  }

  // Fetch user details if editing
  const fetchUserDetails = async id => {
    try {
      const response = await apiRequest(
        process.env.REACT_APP_BASE_URL_INSURER +
        `/api/Insurer/getInsurerById/${id}`,
        'GET',
      )
      if (response.success) {

        const { products } = response.data

        form.setFieldsValue({
          products
        });
      }else {
        const { products } = []

        form.setFieldsValue({
         products
        });
     }
      const response2 = await apiRequest(
        process.env.REACT_APP_BASE_URL_AUTH +
        `/api/Auth/GetUserById/${id}`,
        'GET',
      )
      if (response2.success) {

        let res = response2.data;
        const { firstName, lastName, email, mobileNumber } = res;

        form.setFieldsValue({
          firstName,
          lastName,
          email,
          phone: mobileNumber
        });
      }
    } catch (error) {
      console.error('Error fetching insurer details:', error)
    }
  }

  // Submit form
  const handleSubmit = e => {
    e.preventDefault()
    form.validateFields(async (err, values) => {
      if (err) return
      setLoading(true)
      const payload = { ...values }
      const url = insurerID
        ? process.env.REACT_APP_BASE_URL_INSURER + `/api/Insurer/${insurerID}`
        : process.env.REACT_APP_BASE_URL_INSURER + '/api/Insurer/addNewInsurer'
      const method = 'POST'
      try {
        const response = await apiRequest(url, method, payload)
        if (response.success) {
          toast.success(
            insurerID
              ? 'Insurer updated successfully'
              : 'Insurer added successfully',
          )
          if (onSuccess) onSuccess()
        } else {
          toast.error(response.error)
        }
      } catch (error) {
        toast.error('Something went wrong. Please try again.')
      } finally {
        setLoading(false)
      }
    })
  }

  return (
    <div className="container mt-3">
      <div className="card p-4">
        <Form layout="vertical" onSubmit={handleSubmit}>
          <Row gutter={16}>
            <Col md={12}>
              <Form.Item label="FirstName">
                {getFieldDecorator('firstName', {
                  rules: [{ required: true, message: 'First Name is required' }],
                })(<Input placeholder="Enter First Name" />)}
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item label="LastName">
                {getFieldDecorator('lastName', {
                  rules: [{ required: true, message: 'Last Name is required' }],
                })(<Input placeholder="Enter Last Name" />)}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col md={12}>
              <Form.Item label="Email">
                {getFieldDecorator('email', {
                  rules: [
                    { required: true, message: 'Email is required' },
                    { type: 'email', message: 'Invalid email format' },
                  ],
                })(<Input placeholder="Enter Email" />)}
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item label="Phone Number">
                {getFieldDecorator('phone', {
                  rules: [
                    { required: true, message: 'Phone number is required' },
                    {
                      pattern: /^\d{10}$/,
                      message: 'Phone number must be 10 digits',
                    },
                  ],
                })(<Input placeholder="Enter Phone Number" maxLength={10} />)}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col md={12}>
              <Form.Item label="Select Products">
                {getFieldDecorator('products', {
                  rules: [
                    {
                      required: true,
                      message: 'Please select at least one product',
                    },
                  ],
                })(
                  <Select mode="multiple" placeholder="Select Products">
                    {productList?.map(product => (
                      <Option key={product.productid} value={product.productid}>
                        {product.productname}
                      </Option>
                    ))}
                  </Select>,
                )}
              </Form.Item>
            </Col>
            {/* <Col md={12}>
              <Form.Item label="Select Broker">
                {getFieldDecorator('userIds', {
                  rules: [
                    {
                      required: true,
                      message: 'Please select at least one broker',
                    },
                  ],
                })(
                  <Select mode="multiple" placeholder="Select Broker">
                    {borkerList?.map(broker => (
                      <Option key={broker?.id} value={broker?.id}>
                        {`${broker?.firstName} ${broker?.lastName}`}
                      </Option>
                    ))}
                  </Select>,
                )}
              </Form.Item>
            </Col> */}
          </Row>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              className="btn-success">
              {insurerID ? 'Update insurer' : 'Add insurer'}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  )
}

export default Form.create()(InsurerForm)
